import React from 'react';
import { Switch, Route } from 'react-router';
import { AppRoutes, getAppRouteCacheName } from '../../../routes';
import { DataProviderCache } from '../../../data/DataProviders/DataProviderCache';
import { TimelineOrganizationEvents } from './events/TimelineOrganizationEvents';
import { useSelectedOrganizationData, isRecordFound } from '../../../hooks/data-hooks';
import { LocationsDropdownToolbar } from '../../../components/LocationsDropdownToolbar/LocationsDropdownToolbar';
import { ContentContainer } from '../../../components/ContentContainer';
import { RecordDataIndicators } from '../../../components/RecordDataIndicators';
import { TimelineDataProvider } from '../../../data/DataProviders/TimelineDataProvider';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import { TimelineEventDetailDataProvider } from '../../../data/DataProviders/TimelineEventDetailDataProvider';
import { TimelineOrganizationEventDetails } from './events/TimelineOrganizationEventDetails';
import { useCurrentAppRoute } from '../../../hooks/app-route-hooks';
import { DeviceDataProvider } from '../../../data/DataProviders/DeviceDataProvider';
import { OverviewSiteDeviceDetailsTabView } from '../../overview/locations/devices/OverviewDeviceDetailTabView';

export const TimelineOrganization: React.FC = () => {
    const selectedOrganizationData = useSelectedOrganizationData();
    const currentAppRoute = useCurrentAppRoute();
    const { t } = useLanguageLocale();

    if (!isRecordFound(selectedOrganizationData)) {
        return (
            <>
                <DataProviderCache for="Timeline - Not Found Organization Locations Dropdown Toolbnar">
                    <LocationsDropdownToolbar title={t('DASHBOARD.TIMELINE_TITLE')} />
                </DataProviderCache>

                <ContentContainer>
                    <RecordDataIndicators
                        recordData={selectedOrganizationData}
                        errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                        notFoundIcon="Business"
                        notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
                    />
                </ContentContainer>
            </>
        );
    }

    return (
        <>
            <DataProviderCache for="Timeline Single Organization">
                <TimelineDataProvider organizationIdOrLocationIdOrSiteId={selectedOrganizationData.value.id}>
                    <Switch>
                        <Route exact path={AppRoutes.TimelineOrganization} component={TimelineOrganizationEvents} />
                        <Route path={AppRoutes.TimelineOrganizationEventDetails}>
                            {'alarmId' in currentAppRoute && 'deviceId' in currentAppRoute && (
                                <DataProviderCache for="Timeline Single Organization Single Event">
                                    <TimelineEventDetailDataProvider
                                        alarmId={currentAppRoute.alarmId}
                                        deviceId={currentAppRoute.deviceId}
                                    >
                                        <DeviceDataProvider deviceId={currentAppRoute.deviceId}>
                                            <TimelineOrganizationEventDetails />
                                        </DeviceDataProvider>
                                    </TimelineEventDetailDataProvider>
                                </DataProviderCache>
                            )}
                        </Route>
                    </Switch>
                </TimelineDataProvider>
            </DataProviderCache>

            <Route exact path={AppRoutes.TimelineOrganizationTabDetails}>
                {'deviceId' in currentAppRoute && (
                    <DataProviderCache for={getAppRouteCacheName(AppRoutes.TimelineOrganizationTabDetails)}>
                        <DeviceDataProvider deviceId={currentAppRoute.deviceId}>                          
                            <OverviewSiteDeviceDetailsTabView />
                        </DeviceDataProvider>
                    </DataProviderCache>
                )}
            </Route>
        </>
    );
};
